import { Inbox } from 'lucide-react';

export default function EmptyState({ icon: Icon = Inbox, title = 'No items to display', hint, action }) {
  return (
    <div className="flex flex-col items-center justify-center gap-1 px-6 py-14 text-center">
      <div className="mb-2 flex h-11 w-11 items-center justify-center rounded-full bg-surface-sunken text-content-subtle">
        <Icon size={20} strokeWidth={1.8} />
      </div>
      <p className="text-sm font-semibold text-content">{title}</p>
      {hint && <p className="max-w-sm text-xs text-content-muted">{hint}</p>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
